module.exports = __webpack_public_path__ + "img/classic_rental40_5.a0e398db.jpg";